<template>
  <div>
    <van-sticky>
      <div class="tabs">
        <div
          class="tab-item"
          :class="{ active: tabActive === item.key }"
          @click="handleTab(item.key)"
          v-for="item in GradeRulesTabColumn"
          :key="item.key"
        >
          {{ item.title }}
          <van-icon
            name="question-o"
            @click.stop="isRulesPop = true"
            color="#999"
            v-if="hasGradeRules && item.key === tabActive && !is_anxingtui"
          />
        </div>
      </div>
    </van-sticky>
    <div class="list-wrp">
      <div class="list-box-title" v-if="list.length > 0">
        <div class="vertical-bg"></div>
        <div class="list-box-time">{{ period }}</div>
      </div>
      <template v-for="(item, index) in list" :key="index">
        <div class="list-item">
          <div class="list-title" v-if="item.list.length > 1">
            <div class="title-box">
              <div class="and-icon">&</div>
              <div class="title">同时满足</div>
            </div>
            <!-- <div class="list-period">{{ period }}</div> -->
          </div>
          <div class="list-sub-wrp">
            <div class="list-sub-item" v-for="(subItem, subIndex) in item.list" :key="subIndex">
              <van-divider v-if="subIndex !== 0 && item.list.length !== 1" />
              <div class="list-item-top">
                <div class="title">{{ subItem.name }}</div>
                <!-- <div class="time" v-if="item.list.length === 1">{{ period }}</div> -->
              </div>
              <div v-if="subItem.childProgress?.length">
                <div v-for="childItem in subItem.childProgress" class="child">
                  <div class="list-item-pre">
                    {{ childItem.name }}&nbsp;&nbsp;<span class="active-val"> {{ childItem.value }}</span
                    ><span class="total-val">/{{ childItem.goal }}</span>
                  </div>
                  <div class="list-item-pro">
                    <Progress
                      class="progress"
                      stroke-width="8px"
                      color="#FF97A5"
                      :percentage="childItem.progressRate"
                      :show-pivot="false"
                    />
                    <div class="pre-text">{{ childItem.progressRate }}%</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="list-item-pre">
                  {{ subItem.progress }}&nbsp;&nbsp;<span class="active-val"> {{ subItem.value }}</span
                  ><span class="total-val">/{{ subItem.goal }}</span>
                </div>
                <div class="list-item-pro">
                  <Progress
                    class="progress"
                    stroke-width="8px"
                    color="#FF97A5"
                    :percentage="subItem.progressRate"
                    :show-pivot="false"
                  />
                  <div class="pre-text">{{ subItem.progressRate }}%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider" v-if="index !== list.length - 1">
          <div class="line pre-line"></div>
          <div class="or-word">或</div>
          <div class="line next-line"></div>
        </div>
      </template>
      <van-empty
        v-if="list.length == 0 && !loading"
        image-size="240"
        image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
        description="暂无数据"
      />
    </div>
    <van-popup v-model:show="isRulesPop" round closeable position="bottom" :style="{ minHeight: '30%' }">
      <div class="rule-box">
        <div class="rule-title">{{ GradeRulesTabColumn.filter(d => tabActive === d.key)[0].title }}</div>
        <div class="rule-item" v-for="(item, index) in list" :key="index">
          <div>
            <span>{{ index + 1 }}、</span>
            <template v-for="(subItem, subIndex) in item.list" :key="subIndex">
              <span>{{ subIndex !== 0 && item.list.length !== 1 ? '；' : '' }}</span>
              <span>
                <span>{{ subItem.name }}</span>
                <span v-if="!subItem.childProgress?.length">
                  {{ tabActive === UpDownGradeTypeEnum.UP ? '达到' : '不低于' }}{{ subItem.goal }}{{ subItem.unit }}
                </span>
                <span> </span>
              </span>
            </template>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue'
import { Progress } from 'vant'
import { checkAgentGradeRulesInfoByPuid } from '@/api/user'
import { useUserStore } from '@/store/user'
import { projectRules } from '@/enum'

const userStore = useUserStore()
const is_anxingtui = userStore.getProjectInfo.projectRule === projectRules.anxingtui
const UpDownGradeTypeEnum = { UP: 1, DOWN: 2 }
const GradeRulesTabColumn = [
  { key: UpDownGradeTypeEnum.UP, title: '升级制度' },
  { key: UpDownGradeTypeEnum.DOWN, title: '保级制度' }
]
const tabActive = ref(UpDownGradeTypeEnum.UP)
const list = ref([])
const showPeriodTime = ref('每周')
const period = ref('')
const hasGradeRules = computed(() => list.value.length > 0)
const loading = ref(false)
const getList = async () => {
  try {
    loading.value = true
    const resData = await checkAgentGradeRulesInfoByPuid({ ruleType: tabActive.value })
    list.value = resData.list
    period.value = resData.period
    showPeriodTime.value = resData.showPeriodTime
  } finally {
    loading.value = false
  }
}
const handleTab = key => {
  tabActive.value = key
  getList()
}

const isRulesPop = ref(false)

onMounted(getList)
</script>
<style lang="less" scoped>
.tabs {
  background-color: #fff;
  text-align: center;
  height: 44px;
  line-height: 44px;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  color: #999999;
  .tab-item {
    width: 100%;
    position: relative;
  }
  .active {
    color: #212832;
    &::after {
      content: '';
      position: absolute;
      display: block;
      width: 16px;
      height: 4px;
      background: #ff97a5;
      border-radius: 2px;
      bottom: 0;
      left: 45%;
      // right: 50%;
    }
  }
}
.list-wrp {
  padding-bottom: 20px;
  .list-box-title {
    display: flex;
    align-items: center;
    padding-left: 12px;
    margin-top: 20px;
    margin-bottom: 17px;
    .vertical-bg {
      width: 4px;
      height: 16px;
      background: #ff97a5;
      border-radius: 8px;
      margin-right: 8px;
    }
    .list-box-time {
      font-size: 16px;
      font-weight: 500;
    }
  }
  .list-item {
    margin: 12px;
    // padding: 16px;
    background-color: #fff;
    border-radius: 8px;
    .list-title {
      background: linear-gradient(90deg, #fff6e7 0%, rgba(255, 255, 255, 0) 100%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      .title-box {
        display: flex;
        align-items: center;
        .title {
          font-weight: 500;
          font-size: 16px;
        }
      }
      .and-icon {
        color: #fff;
        width: 18px;
        height: 18px;
        text-align: center;
        line-height: 18px;
        border-radius: 50%;
        font-size: 12px;
        background: linear-gradient(149deg, #ffd73e 0%, #ffba3c 100%);
        margin-right: 6px;
      }
      // .list-period {
      //   color: #999999;
      //   font-size: 12px;
      // }
    }
    .list-sub-wrp {
      padding: 16px;
      .list-sub-item {
        // padding: 0 16px;
        .list-item-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          .title {
            font-size: 14px;
            font-weight: bold;
            color: #222222;
          }
          // .time {
          //   color: #999999;
          //   font-weight: 400;
          //   font-size: 11px;
          // }
        }
        .list-item-pre {
          font-size: 12px;
          margin-bottom: 9px;
          .active-val {
            font-weight: bold;
            font-size: 14px;
          }
          .total-val {
            color: #999;
          }
        }
        .child {
          margin-bottom: 16px;
        }
        .list-item-pro {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .progress {
            flex: 1;
            margin-right: 10px;
          }
          .pre-text {
            font-weight: 500;
            color: #ff97a5;
            width: 34px;
            text-align: right;
          }
        }
      }
    }
  }
  .divider {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 12px 0;
    color: #999999;
    .line {
      width: 80px;
      height: 1px;
    }
    .or-word {
      margin: 0 10px;
    }
    .pre-line {
      background: linear-gradient(270deg, rgba(201, 201, 201, 0.3) 0%, rgba(153, 153, 153, 0) 100%);
    }
    .next-line {
      background: linear-gradient(90deg, rgba(201, 201, 201, 0.3) 0%, rgba(153, 153, 153, 0) 100%);
    }
  }
}
.rule-box {
  font-size: 14px;
  padding: 16px;
  .rule-title {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
  }
  .rule-item {
    margin-top: 10px;
  }
}
</style>
